import { request } from '../../../utils/api';
import actions from '../../../constants/actions';
import { REGEN_SESSION_TOKEN } from '../../../constants/endpoints';
import getAnalyticsHeaders from '../../../utils/analytics-client-info';

export const regenerateSessionToken = () => async (dispatch) => {
  dispatch({ type: actions.REGENERATE_SESSION_TOKEN, status: 'started' });
  try {
    const response = await request({
      route: REGEN_SESSION_TOKEN(),
      method: 'post',
      dispatch,
      headers: getAnalyticsHeaders(),
    });
    dispatch({
      type: actions.REGENERATE_SESSION_TOKEN,
      status: 'success',
      response,
    });
  } catch (error) {
    dispatch({
      type: actions.REGENERATE_SESSION_TOKEN,
      status: 'error',
      error: error.message,
    });
  }
};
